import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SectionConfig } from '../../models/app.config.models';
import { BibleCoursesComponent } from '../bible-courses/bible-courses.component';
import { CalendarListViewComponent } from '../calendar-list-view/calendar-list-view.component';
import { DescriptionBlockComponent } from '../description-block/description-block.component';
import { ImageCardComponent } from '../image-card/image-card.component';
import { MapWidgetComponent } from '../map-widget/map-widget.component';
import { PreachingPlaylistsComponent } from '../preaching-playlists/preaching-playlists.component';
import { QuickLinksComponent } from '../quick-links/quick-links.component';
import { RecentServices } from '../recent-services/recent-services.component';
import { SearchboxComponent } from '../searchbox/searchbox.component';
import { VerseOfTheDayComponent } from '../verse-of-the-day/verse-of-the-day.component';
import { VideoGalleryComponent } from '../video-gallery/video-gallery.component';

@Component({
  selector: 'lsa-section-renderer',
  imports: [
    DescriptionBlockComponent,
    VerseOfTheDayComponent,
    MapWidgetComponent,
    ImageCardComponent,
    QuickLinksComponent,
    SearchboxComponent,
    CalendarListViewComponent,
    RecentServices,
    PreachingPlaylistsComponent,
    BibleCoursesComponent,
    VideoGalleryComponent
  ],
  templateUrl: './section-renderer.component.html',
  styleUrl: './section-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionRendererComponent {
  readonly sectionConfig = input.required<SectionConfig>();
  readonly title = computed(() => this.sectionConfig().title);
  readonly backgroundColor = computed(
    () => this.sectionConfig().backgroundColor ?? 'var(--mat-sys-background)'
  );
  readonly textColor = computed(
    () => this.sectionConfig().textColor ?? 'var(--mat-sys-on-background)'
  );
  readonly textAlign = computed(() => this.sectionConfig().textAlign ?? 'left');
}
